var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},[(_vm.title)?_c('div',{staticClass:"info-title"},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_c('div',{staticClass:"info-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }